/* Vanty Elara: scripts globales */
(function () {
  'use strict';
  var V = window.vanty || { routes: { root: '/', cart: '/cart' }, moneyFormat: '${{amount}}', cartType: 'drawer' };
  var root = (V.routes.root || '/').replace(/\/?$/, '/');
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Formato de dinero ---------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = V.moneyFormat || '${{amount}}';
    var value = (Number(cents) / 100);
    function withDelims(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts.join(decimal);
    }
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var out;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': out = withDelims(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = withDelims(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = withDelims(value, 0, '.', ','); break;
      default: out = withDelims(value, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Aviso flotante ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#Toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2800);
  }

  /* ---------- Paneles (carrito, menu, busqueda) ---------- */
  var overlay = $('#Overlay');
  function lock(on) { document.body.classList.toggle('is-locked', !!on); }
  function closeAll() {
    var d = $('#CartDrawer'); if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); }
    var m = $('#MobileMenu'); if (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); }
    var s = $('#SearchModal'); if (s) s.hidden = true;
    if (overlay) overlay.hidden = true;
    lock(false);
  }
  function openDrawer() {
    var d = $('#CartDrawer');
    if (!d) { window.location.href = V.routes.cart; return; }
    closeAll();
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    lock(true);
    renderCart();
    d.focus();
  }
  function openMenu() {
    closeAll();
    var m = $('#MobileMenu'); if (!m) return;
    m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    lock(true);
  }
  function openSearch() {
    closeAll();
    var s = $('#SearchModal'); if (!s) return;
    s.hidden = false;
    if (overlay) overlay.hidden = false;
    var i = $('#SearchInput'); if (i) setTimeout(function () { i.focus(); }, 50);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-close-all]')) { e.preventDefault(); closeAll(); return; }
    if (t.closest('[data-open-menu]')) { e.preventDefault(); openMenu(); return; }
    if (t.closest('[data-open-search]')) { e.preventDefault(); openSearch(); return; }
    if (t.closest('[data-open-cart]') && V.cartType === 'drawer' && document.body.className.indexOf('template-cart') === -1) {
      e.preventDefault(); openDrawer(); return;
    }
    var qa = t.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); addToCart({ items: [{ id: Number(qa.getAttribute('data-quick-add')), quantity: 1 }] }, qa); return; }
    var dq = t.closest('[data-line-change]');
    if (dq) { e.preventDefault(); changeLine(dq.getAttribute('data-key'), Number(dq.getAttribute('data-line-change'))); return; }
    var rec = t.closest('[data-toggle-recover]');
    if (rec) {
      e.preventDefault();
      var a = $('#LoginBox'), b = $('#RecoverBox');
      if (a && b) { a.hidden = !a.hidden; b.hidden = !b.hidden; }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- Carrito AJAX ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
  }
  function renderCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        var body = $('#CartDrawerBody'), foot = $('#CartDrawerFoot');
        if (!body) return cart;
        if (!cart.item_count) {
          body.innerHTML = '<div class="drawer__empty"><p>Tu carrito est&aacute; vac&iacute;o.</p><a class="btn btn--primary" href="' + (window.vanty && window.vanty.routes.root || '/') + 'collections/all">Ver productos</a></div>';
          if (foot) foot.hidden = true;
          return cart;
        }
        body.innerHTML = cart.items.map(function (it) {
          var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
          var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="d-item__variant">' + escapeHtml(it.variant_title) + '</span>' : '';
          return '<div class="d-item">' +
            '<a class="d-item__img" href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
            '<div><a class="d-item__title" href="' + it.url + '">' + escapeHtml(it.product_title) + '</a>' + variant +
            '<div class="d-item__qty"><button type="button" aria-label="Disminuir" data-key="' + it.key + '" data-line-change="' + (it.quantity - 1) + '">&minus;</button><span>' + it.quantity + '</span><button type="button" aria-label="Aumentar" data-key="' + it.key + '" data-line-change="' + (it.quantity + 1) + '">+</button></div>' +
            '<button type="button" class="d-item__remove" data-key="' + it.key + '" data-line-change="0">Eliminar</button></div>' +
            '<div class="d-item__price">' + formatMoney(it.final_line_price) + '</div></div>';
        }).join('');
        var sub = $('#CartDrawerSubtotal'); if (sub) sub.textContent = formatMoney(cart.total_price);
        if (foot) foot.hidden = false;
        return cart;
      })
      .catch(function () {});
  }
  function changeLine(key, qty) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function () { return renderCart(); });
  }
  function addToCart(payload, btn) {
    var label;
    if (btn) { btn.disabled = true; label = btn.innerHTML; btn.innerHTML = 'Agregando&hellip;'; }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        if (!res.ok) { toast(res.data.description || res.data.message || 'No se pudo agregar el producto'); return; }
        if (V.cartType === 'page') { window.location.href = V.routes.cart; return; }
        openDrawer();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        toast('Hubo un problema. Intenta de nuevo.');
      });
  }

  /* ---------- Formulario de producto ---------- */
  function initProduct(section) {
    var form = $('#ProductForm', section);
    if (!form) return;
    var jsonEl = $('[data-product-json]', section);
    var variants = [];
    try { variants = jsonEl ? JSON.parse(jsonEl.textContent) : []; } catch (err) { variants = []; }
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-button]', form);
    var qtyInput = $('.qty__input', form);

    $$('[data-qty]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(b.getAttribute('data-qty')));
        qtyInput.value = v;
      });
    });

    function selectedOptions() {
      var groups = $$('.option', form);
      return groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; });
    }
    function onOptionChange() {
      var opts = selectedOptions();
      $$('[data-option-value]', form).forEach(function (el, i) { el.textContent = opts[i] || ''; });
      var v = variants.filter(function (x) {
        return opts.every(function (o, i) { return x['option' + (i + 1)] === o; });
      })[0];
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = 'No disponible';
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Agregar al carrito' : 'Agotado';
      var priceEl = $('[data-price]', section), cmpEl = $('[data-compare-price]', section), wrap = $('[data-price-wrapper]', section);
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (cmpEl) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        cmpEl.hidden = !sale;
        cmpEl.textContent = sale ? formatMoney(v.compare_at_price) : '';
        if (wrap) wrap.classList.toggle('price--sale', !!sale);
      }
      if (v.featured_media && v.featured_media.id) showMedia(section, v.featured_media.id);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    $$('.option input', form).forEach(function (i) { i.addEventListener('change', onOptionChange); });

    form.addEventListener('submit', function (e) {
      if (V.cartType === 'page') return;
      e.preventDefault();
      addToCart({ items: [{ id: Number(idInput.value), quantity: parseInt(qtyInput.value, 10) || 1 }] }, addBtn);
    });

    $$('[data-thumb]', section).forEach(function (t) {
      t.addEventListener('click', function () { showMedia(section, t.getAttribute('data-thumb')); });
    });
  }
  function showMedia(section, id) {
    var found = false;
    $$('.product__slide', section).forEach(function (s) {
      var on = String(s.getAttribute('data-media-id')) === String(id);
      if (on) found = true;
      s.classList.toggle('is-active', on);
    });
    if (!found) return;
    $$('[data-thumb]', section).forEach(function (t) { t.classList.toggle('is-active', String(t.getAttribute('data-thumb')) === String(id)); });
  }

  /* ---------- Slider de portada ---------- */
  function initSlider(el) {
    var slides = $$('.hero__slide', el);
    var dots = $$('.hero__dot', el);
    if (slides.length < 2) return;
    var cfg = $('[data-autoplay]', el);
    var autoplay = cfg && cfg.getAttribute('data-autoplay') === 'true';
    var speed = (cfg && Number(cfg.getAttribute('data-speed')) || 6) * 1000;
    var i = 0, timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function start() { if (autoplay) { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, speed); } }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(Number(d.getAttribute('data-slide-to'))); start(); }); });
    var x0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); start(); }
      x0 = null;
    });
    start();
  }

  /* ---------- Barra de anuncios ---------- */
  function initAnnouncement(el) {
    var items = $$('.announcement__item', el);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  }

  /* ---------- Busqueda predictiva ---------- */
  function initPredictive() {
    var input = $('[data-predictive-input]');
    var out = $('#PredictiveResults');
    if (!input || !out) return;
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var ps = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!ps.length) { out.innerHTML = '<p class="drawer__empty">Sin resultados para &ldquo;' + escapeHtml(q) + '&rdquo;</p>'; return; }
            out.innerHTML = ps.map(function (p) {
              return '<a class="p-result" href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
                '<span>' + escapeHtml(p.title) + '</span><span class="p-result__price">' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span></a>';
            }).join('') + '<p style="margin-top:16px"><a class="link-arrow" href="' + V.routes.search + '?type=product&q=' + encodeURIComponent(q) + '">Ver todos los resultados</a></p>';
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* ---------- Filtros de coleccion ---------- */
  function initFilters() {
    var form = $('#FiltersForm');
    if (!form) return;
    $$('[data-auto-submit]', form).forEach(function (el) {
      el.addEventListener('change', function () { form.submit(); });
    });
    document.addEventListener('click', function (e) {
      $$('.filter[open]', form).forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
  }

  /* ---------- Productos relacionados ---------- */
  function initRecos() {
    var el = $('[data-recos]');
    if (!el || el.children.length) return;
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-recos]');
        if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- Aviso de cookies (API de privacidad de Shopify) ---------- */
  function initCookies() {
    var banner = $('#CookieBanner');
    if (!banner) return;
    var KEY = 'vanty_cookie_choice';
    var stored = null;
    try { stored = localStorage.getItem(KEY); } catch (e) {}

    function setConsent(accepted) {
      try { localStorage.setItem(KEY, accepted ? 'accept' : 'decline'); } catch (e) {}
      banner.hidden = true;
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && typeof api.setTrackingConsent === 'function') {
        api.setTrackingConsent({ analytics: accepted, marketing: accepted, preferences: accepted, sale_of_data: accepted }, function () {});
      }
    }
    function decide(api) {
      if (stored) return;
      if (api && typeof api.shouldShowBanner === 'function' && !api.shouldShowBanner()) {
        // La region no requiere banner; aun asi mostramos el aviso informativo una vez.
      }
      banner.hidden = false;
    }
    $$('[data-cookie]', banner).forEach(function (b) {
      b.addEventListener('click', function () { setConsent(b.getAttribute('data-cookie') === 'accept'); });
    });
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        decide(err ? null : window.Shopify.customerPrivacy);
      });
    } else {
      decide(null);
    }
  }

  /* ---------- Inicio ---------- */
  function init() {
    $$('[data-slider]').forEach(initSlider);
    $$('[data-announcement]').forEach(initAnnouncement);
    $$('[data-product-section]').forEach(initProduct);
    initPredictive();
    initFilters();
    initRecos();
    initCookies();
    var country = $$('select[data-default]');
    country.forEach(function (s) { var d = s.getAttribute('data-default'); if (d) s.value = d; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-slider]', e.target).forEach(initSlider);
    $$('[data-announcement]', e.target).forEach(initAnnouncement);
    $$('[data-product-section]', e.target).forEach(initProduct);
  });

  window.vantyCart = { open: openDrawer, refresh: renderCart, add: addToCart };
})();
